module.exports = __webpack_public_path__ + "static/media/ic_no_doc.a0d88e29.svg";